module.exports = __webpack_public_path__ + "static/media/visitor2.6a9cd198.jpg";